import { ActionTree } from "vuex";
import { ActionCallback, RootState } from "../types";
import { MyCourseState } from "./types";
import MyCourseService from "@/services/myCourse.service";
import { AxiosError, AxiosResponse } from "axios";
const service: MyCourseService = new MyCourseService();

export const actions: ActionTree<MyCourseState, RootState> = {
  getMyCourse(_, callback: ActionCallback) {
    service
      .getMyCourse(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  getMyCourseDetail(_, callback: ActionCallback) {
    service
      .getMyCourseDetail(callback?.params.slug)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  submitAssessment(_, callback: ActionCallback) {
    service
      .submitAssessment(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  setContent(_, callback: ActionCallback) {
    service
      .setContent(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  setRating(_, callback: ActionCallback) {
    service
      .setRating(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  getCertificate(_, callback: ActionCallback) {
    service
      .getCertificate(callback?.params.id)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
};
